import { render, staticRenderFns } from "./CustomerSlots.vue?vue&type=template&id=f5bb66dc&"
import script from "./CustomerSlots.vue?vue&type=script&lang=js&"
export * from "./CustomerSlots.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSlots.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports